(function () {
  'use strict';

  var LOCALE_KEY  = 'gs_locale';
  var COUNTRY_KEY = 'gs_country';

  // ── storage helpers (localStorage — persiste entre tabs e sessões) ──
  function store(k, v)  { try { localStorage.setItem(k, v);    } catch (e) {} }
  function read(k)      { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function remove(k)    { try { localStorage.removeItem(k);     } catch (e) {} }

  // ── detecta locale no URL actual (/pt/...) ──
  function getPathLocale() {
    var m = window.location.pathname.match(/^\/([a-z]{2,5}(?:-[a-z]{2,4})?)(\/|$)/i);
    if (!m) return null;
    var seg = m[1].toLowerCase();
    var skip = ['collections','products','pages','blogs','account','cart','checkout','search','policies','apps'];
    return skip.indexOf(seg) === -1 ? seg : null;
  }

  // ────────────────────────────────────────────────────
  // LOCALE — lógica de arranque
  // ────────────────────────────────────────────────────
  var urlLocale = getPathLocale();

  // 1. Actualiza o store a partir do URL (source of truth)
  if (urlLocale) {
    store(LOCALE_KEY, urlLocale);
  } else if (!read(LOCALE_KEY)) {
    store(LOCALE_KEY, 'en');
  }

  // 2. Se há locale guardado != EN mas o URL não tem prefixo → redirecionar
  var storedLocale = read(LOCALE_KEY);
  if (storedLocale && storedLocale !== 'en' && !urlLocale) {
    var skipPaths = ['/checkout', '/cart', '/account', '/apps/'];
    var onSkip = skipPaths.some(function (p) { return window.location.pathname.indexOf(p) === 0; });
    if (!onSkip) {
      window.location.replace(
        '/' + storedLocale +
        window.location.pathname +
        window.location.search +
        window.location.hash
      );
      return; // para aqui — a página vai recarregar
    }
  }

  // ────────────────────────────────────────────────────
  // LOCALE — interceptar cliques em links internos
  // Adiciona o prefixo de locale a qualquer link que não o tenha
  // ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    // Sobe o DOM até encontrar um <a>
    var el = e.target;
    while (el && el.tagName !== 'A') el = el.parentElement;
    if (!el) return;

    // Ignora: links de localização, hreflang, âncoras, mailto, tel, js
    if (el.hasAttribute('hreflang') || el.closest('localization-form')) return;
    var href = el.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return;

    // Ignora links externos
    if (/^https?:\/\//i.test(href) && href.indexOf(window.location.hostname) === -1) return;

    var locale = read(LOCALE_KEY);
    if (!locale || locale === 'en') return; // EN não tem prefixo

    // Extrai só o path+search+hash
    var path = href;
    if (/^https?:/i.test(href)) {
      try { var u = new URL(href); path = u.pathname + u.search + u.hash; }
      catch (ex) { return; }
    }

    // Já tem o prefixo?
    if (path === '/' + locale || path.indexOf('/' + locale + '/') === 0) return;

    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/' + locale + (path.charAt(0) === '/' ? path : '/' + path);
  }, true /* capture — antes de outros handlers */);

  // ────────────────────────────────────────────────────
  // LOCALE — quando o utilizador muda o idioma na dropdown
  // Actualiza o valor guardado para o novo idioma
  // ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el.tagName !== 'A') el = el.parentElement;
    if (!el) return;
    if (!el.hasAttribute('hreflang') && !el.closest('.language-selector')) return;
    var val = el.getAttribute('data-value') || el.getAttribute('hreflang');
    if (!val) return;
    store(LOCALE_KEY, val.split('-')[0].toLowerCase());
  });

  // ────────────────────────────────────────────────────
  // LOGOUT — limpa o estado guardado
  // ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el.tagName !== 'A') el = el.parentElement;
    if (el && el.href && /\/account\/logout|\/logout/.test(el.href)) {
      remove(LOCALE_KEY);
      remove(COUNTRY_KEY);
    }
  });

  // ────────────────────────────────────────────────────
  // CURRENCY — guardar país quando o utilizador selecciona
  // ────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el.tagName !== 'A') el = el.parentElement;
    if (!el) return;
    var val = el.getAttribute('data-value');
    // Códigos de país = 2 letras maiúsculas (PT, US, GB...)
    if (val && /^[A-Z]{2}$/.test(val)) {
      store(COUNTRY_KEY, val);
    }
  });

  // ────────────────────────────────────────────────────
  // CURRENCY — restaurar na chegada à página
  // Se o país guardado != país actual, faz POST silencioso
  // para que o Shopify actualize o cookie _shopify_country
  // ────────────────────────────────────────────────────
  var storedCountry = read(COUNTRY_KEY);
  if (storedCountry) {
    document.addEventListener('DOMContentLoaded', function () {
      var input = document.querySelector('input[name="country_code"]');
      if (!input || input.value === storedCountry) return;
      var form = input.closest('form');
      if (!form) return;

      // Actualiza o input e submete silenciosamente
      input.value = storedCountry;
      var fd = new FormData(form);
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'localization', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        redirect: 'follow'
      }).catch(function () { /* silencioso */ });
    });
  }

})();
